import React, { useState } from 'react';
import styles from './Balance.module.css';
import ChevronIcon from '../../icons/chevronIcon';
import { useTranslation } from 'react-i18next';
import Money from '../../Common/Money/Money';
import { useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';



const BalanceConsumer = ({ points, organization }) => {
  const currency = useSelector((state) => state.currency.default);
  const [activeButton, setActiveButton] = useState(null);
  const history = useHistory();
  const { t } = useTranslation();
  const user = useSelector((state) => state.associates.user);
  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  return (
    <div className='card p-3'>
      <div className='row px-3'>
        <div>
          <div className='fw-semibold'>Reward {currency?.name}</div>
          <div className='text-secondary font-smaller'>
            {t('behalfofGrupoRosaNegra', { organization })}
          </div>

          <div className='row mt-3'>
            <div className='col font-extra-large fw-semibold'>
              <Money value={user.currentLoyalty.points} currency={currency} symbolSize='.85rem' />
            </div>
            <div  onClick={() => history.push(`/points`)} className='col-auto align-self-end text-tertiary'>
              {t('myPoints')} <span className='text-white'>{points}</span> <ChevronIcon size={15} />
            </div>
          </div>

          <div className={styles.lineaGris}></div>

          <div className={styles.rectanglesContainer}>
            <button
              className={`${styles.rectangle} ${activeButton === 'buy' ? styles.activeButton : ''}`}
              onClick={() => handleButtonClick('buy')}
            >
              {t('consumer.buyPoints')}
            </button>
            <button
              className={`${styles.rectangle} ${
                activeButton === 'redeem' ? styles.activeButton : ''
              }`}
              onClick={() => handleButtonClick('redeem')}
            >
              {t('consumer.redeemPoints')}
            </button>
            <button
              className={`${styles.rectangle} ${
                activeButton === 'transfer' ? styles.activeButton : ''
              }`}
              onClick={() => handleButtonClick('transfer')}
            >
              {t('consumer.transferPoints')}
            </button>
            <button
              className={`${styles.rectangle} ${
                activeButton === 'other' ? styles.activeButton : ''
              }`}
              onClick={() => handleButtonClick('other')}
            >
              {t('consumer.otherOptions')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BalanceConsumer;
